import React from "react";
import SettingImg from "../../../assets/images/setting.png";

const EditIcon = () => {
  return <img src={SettingImg} className="sett" />;
};

export default EditIcon;
